export const CREATE_RESPONSE = "CREATE_RESPONSE";
export const CREATE_SET_FIELD = "CREATE_SET_FIELD";
export const CREATE_SET_STEP = "CREATE_SET_STEP";
export const CREATE_ERROR = "CREATE_ERROR";
export const RESTORE_SET_ERROR = "RESTORE_SET_ERROR";
export const RESTORE_SET_RESPONSE = "RESTORE_SET_RESPONSE";
export const ACTION_SET_IS_LOADING = "ACTION_SET_IS_LOADING";
export const ACTION_SET_ERROR = "ACTION_SET_ERROR";
export const ACTION_UNSET_ERROR = "ACTION_UNSET_ERROR";
export const VERIFY_SET_ERROR = "VERIFY_SET_ERROR";
export const SET_USER_ALREADY_EXIST = "SET_USER_ALREADY_EXIST";
export const ACTION_SET_TOKEN = "ACTION_SET_TOKEN";
export const SET_USER_VERIFIED = "SET_USER_VERIFIED";
export const SET_USER_DOES_NOT_EXIST = "SET_USER_DOES_NOT_EXIST";
export const RESET = "RESET";
export const SET_SEND_EMAIL = "SET_SEND_EMAIL";
export const SET_NOTIFICATION = "SET_NOTIFICATION";
export const SET_NOT_VALID_TOKEN = "SET_NOT_VALID_TOKEN";
